import { useEffect } from 'react'
import { matchPath, Navigate, useParams, useSearchParams } from 'react-router'

import { Paths } from '~/App'
import { useAuth } from '~/App/Auth/AuthProvider'

import NotFoundPage from '../../404'

function useAppIdParam() {
  const { appId } = useParams<{ appId: string }>()
  if (!appId) {
    throw new Error('unable to get appId')
  }
  return appId
}

const AuthAppIdPage = () => {
  const appId = useAppIdParam()
  const [searchParams] = useSearchParams()
  const { auth } = useAuth()

  const inRedirect = searchParams.get('redirect')
  const redirect = inRedirect
    ? Object.values(Paths).find(path => matchPath(path, inRedirect)) && inRedirect
    : undefined

  useEffect(() => {
    if (redirect) {
      auth(appId)
    }
  }, [appId])

  if (!redirect) {
    return <NotFoundPage />
  }

  return <Navigate to={redirect} replace />
}

export default AuthAppIdPage
